import { InjectionToken } from '@angular/core';

export const ANALYTICS_PRIVACY_POLICY_LINK = new InjectionToken<string>(
    'analytics-privacy-policy-link-injection-token'
);
